import React from 'react';
import { v4 as uuid } from 'uuid';

import { UpdateConsent } from '../../actions';
import { StringKeyValue } from '../../actions/types';
import { ConsentReducer } from '../../reducers/consent';
import Consent from './Consent';

interface Props {
    updateConsent: (name: UpdateConsent['name'], value: UpdateConsent['value']) => void;
    consent: ConsentReducer;
    text: StringKeyValue;
}

const ConsentList = ({ updateConsent, consent, text }: Props): JSX.Element => (
    <>
        {!!consent.data.length && (
            <div className="consent">
                {consent.data.map((c) => (
                    <Consent key={uuid()} data={c} updateConsent={updateConsent} text={text} />
                ))}
            </div>
        )}
    </>
);

export default ConsentList;
